import './stickyAnimation';
import './arcgis';
import initLottieAnimations from './lottieAnimations';
import initTextIntroTransitions from './textIntroAnimations';

// Load and play all animations
// EXCEPT the Lab to Consumer animation (text-linked animation)
initLottieAnimations();

// Initialize all text-intro animations.
// These are regular blocks of text have a simple
// slide-into-view animation when they enter the viewport.
initTextIntroTransitions();
